export enum LoadingStatus {
    IDLE = 'IDLE',
    PENDING = 'PENDING',
}
